const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',
	classHeaderHidden: 'is-hidden',
	lastScrollTop: 0,

	/** @description Initialize */
	init: function() {
		this.headerSticky();
		$(document).on('scroll', this.headerSticky.bind(this));
		$(window).on('load', this.headerSticky.bind(this));
		console.log('Header initialized');
	},

	headerSticky: function() {
		const scrollTop = $(document).scrollTop();

		this.$domHeader.toggleClass(this.classHeaderScroll, scrollTop > 20);

		if (scrollTop > this.lastScrollTop && scrollTop > 80) {
			this.$domHeader.addClass(this.classHeaderHidden);
		} else {
			this.$domHeader.removeClass(this.classHeaderHidden);
		}

		this.lastScrollTop = scrollTop;
	},
};

export default Header;
